import { render } from "./PastPayments.vue?vue&type=template&id=765e1515"
import script from "./PastPayments.vue?vue&type=script&lang=js"
export * from "./PastPayments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__